import { createSlice } from "@reduxjs/toolkit";

export const ConfigSlice = createSlice({
  name: "config",
  initialState: {
    config: {},
  },
  reducers: {
    saveConfigData: (state, action) => {
      state.config = action.payload;
    }
  }
});

export const { saveConfigData } = ConfigSlice.actions;
export default ConfigSlice.reducer;